import Styled from 'styled-components'

export const Button = Styled.button`
    width: ${props => props.width ? props.width : '100%'};
    color: ${props => props.outline ? 'var(--primary-color)' : 'var(--button-primary-text)'};
    background-color: ${props => props.outline ? 'transparent' : props.bgDisabled ? props.bgDisabled : 'var(--button-primary-color)'};
    border: 0;
    font-weight: 600;
    font-size: 14px;
    padding: 7px 10px;
    border-radius: 4px;
    border: 1px solid ${props => props.bgDisabled ? props.bgDisabled : 'var(--primary-color)'};
    
    svg {
        margin-top: -3px;
    }

:active{
    opacity: 0.6;
}
`